import http from "./http.js";

/********* 志愿者 **********/
export const volunteer = {
    /**
     * 获取token接口
     */
    getToken: function(parmas) {
        return http.postRequestForm("/oauth/token/phoneWeb", Object.assign({
            appId: "xc4cvxAagnxh1nCgqapq",
            grantType: "token",
            verifyType: "1"
        }, parmas))
    },
    /**
     * 获取refreshToken接口
     * @param {*} refreshToken
     */
    getRefreshToken: function(refreshToken) {
        return http.postRequestForm("/oauth/token/phoneWeb", {
            appId: "xc4cvxAagnxh1nCgqapq",
            grantType: "refresh_token",
            refreshToken
        })
    },
    /**
     * 获取验证码接口
     */
     getCode: function(mainId, phoneNumber) {
        return http.postRequestForm("/oauth/codeVerifyOfPhoneLogin", {
            appId: "xc4cvxAagnxh1nCgqapq",
            grantType: "token",
            verifyType: "1",
            userType: '1',
            phoneNumber,
            mainId
        })
    },
    // 志愿者用户详情
    getInfo: function(params) {
        return http.postRequestToken("/uc/volunteer/account/user/detail", params)
    },
    // 完善个人信息
    updateInfo: function(params) {
        return http.postRequestToken("/uc/volunteer/account/update", params)
    },
    // 个人报名
    enroll: function(params) {
        return http.postRequest("/uc/volunteer/account/enroll", params)
    }
}